import React from 'react';
import { Helmet } from 'react-helmet'; // Import Helmet for SEO
import './Services.css'; // Include the updated CSS

function Services() {
  return (
    <div className="services">
      {/* Helmet for SEO */}
      <Helmet>
      <div className="about-header text-center py-5">
        <h1>About Doggy Duty WNY</h1>
        <p className="tagline">"Keeping yards clean, one scoop at a time!"</p>
      </div>
        <title>Services | Doggy Duty - Pet Waste Removal </title>
        <meta
          name="description"
          content="Learn more about Doggy Duty, Buffalo’s trusted pet waste removal service. We keep your yard clean and safe for pets and family with reliable and eco-friendly solutions."
        />
        <meta
          name="keywords"
          content="dog waste removal Buffalo, pet waste removal Buffalo, poop scooping service, yard cleaning for dogs, eco-friendly pet waste disposal, landscaping cleanup, pet-friendly lawn care, Buffalo yard maintenance, dog waste management, lawn sanitation, poop pickup service, pet-friendly outdoor maintenance, affordable yard cleaning Buffalo, professional pet waste cleanup, dog poop removal Buffalo, pet-friendly home services, Buffalo NY lawn care, pet hygiene services, residential and commercial poop scooping, waste-free yard service, local pet waste disposal Buffalo, dog poop pickup Buffalo, dog-friendly yard maintenance Buffalo, professional poop scooping Buffalo, hygienic pet waste disposal Buffalo, pooper scooper services Buffalo, safe yard for kids and pets Buffalo"
        />
        <meta name="author" content="Doggy Duty" />
        <meta name="robots" content="index, follow" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Doggy Duty" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:image" content="https://www.doggyduty.com/assets/doggy-duty-logo.jpg" />
        <meta property="og:url" content="https://www.doggyduty.com/about" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Doggy Duty - Buffalo’s Trusted Poop Scooping Service" />
        <meta name="twitter:description" content="We provide top-tier pet waste removal services in Buffalo, NY, keeping your yard clean and pet-friendly!" />
        <meta name="twitter:image" content="https://www.doggyduty.com/assets/doggy-duty-banner.jpg" />

        {/* Structured Data (JSON-LD) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Doggy Duty",
            "image": "https://www.doggyduty.com/assets/doggy-duty-logo.jpg",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Main St",
              "addressLocality": "Buffalo",
              "addressRegion": "NY",
              "postalCode": "14201",
              "addressCountry": "US"
            },
            "telephone": "+1-716-555-1234",
            "url": "https://www.doggyduty.com",
            "description": "Buffalo’s top pet waste removal service, ensuring clean and safe yards for pets and families.",
            "sameAs": [
              "https://www.facebook.com/DoggyDuty",
              "https://www.instagram.com/DoggyDuty",
              "https://www.twitter.com/DoggyDuty"
            ],
            "serviceProvided": {
              "@type": "Service",
              "name": "Pet Waste Removal",
              "areaServed": {
                "@type": "Place",
                "name": "Buffalo, NY and surrounding areas"
              },
              "provider": {
                "@type": "LocalBusiness",
                "name": "Doggy Duty"
              }
            },
            "openingHours": "Mo-Fr 08:00-18:00, Sa 09:00-14:00",
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "42.8864",
              "longitude": "-78.8784"
            }
          })}
        </script>
      </Helmet>
      <div className="about-header text-center py-5">
        <h1>Our Services</h1>
      </div>

      <div className="container">
        {/* Custom Services Header */}
        <section className="custom-services-list text-center py-5">
          <h2 className="custom-services-header-title fw-bold">Professional Pet Waste Removal Services</h2>
          <p className="">
          At Doggy Duty WNY, we specialize in professional pet waste removal services designed to keep your yard clean, odor-free, and safe for both pets and family. Using a systematic grid-pattern cleaning method, we meticulously scan every inch of your yard to ensure no waste is left behind, prioritizing high-traffic areas like patios, play zones, and dog run paths.
          </p>
          <p>
          We utilize specialized, sanitized scooping tools that prevent cross-contamination, ensuring each visit meets the highest health and safety standards. We also include pet-safe deodorizers and disinfectants that neutralize lingering odors and eliminate bacteria, keeping your yard fresh and hygienic.
          </p>
          <p>
            Our services are flexible and affordable to accommodate your needs. We provide year-round waste removal, including in winter months, ensuring your outdoor spaces remain clean no matter the season. Customer satisfaction is our priority, and we back our services with a 100% satisfaction guarantee—if you're not happy, we’ll make it right. Let us handle the mess so you can enjoy a worry-free, spotless yard!
          </p>
        </section>

        {/* Services Section
        <section className="services-list py-5">
          <div className="row text-center">
            {["Weekly Cleanup", "One-Time Cleanup", "Yard Deodorizing", "Commercial Services"].map((service, index) => (
              <div className="col-md-3 d-flex" key={index}>
                <div className="service-card flex-grow-1 p-4 shadow rounded bg-white">
                  <h3 className="">{service}</h3>
                  <p className="text-muted">{[
                    "Regular poop scooping service to keep your yard consistently clean and fresh. Our weekly cleanup service is ideal for busy pet owners who want to maintain a pristine yard without the hassle of constant maintenance.",
                    "Need a quick clean before an event? We’ve got you covered with a one-time deep cleanup. Whether you’re hosting a backyard party, preparing for a family gathering, or simply want a fresh start, our professional team will ensure every inch of your yard is spotless.",
                    "Our eco-friendly deodorizing service eliminates pet odors, keeping your yard fresh. Over time, pet waste can create lingering smells that disrupt your outdoor enjoyment. Our specialized deodorizing treatments neutralize odors at the source.",
                    "We provide pet waste management solutions for apartments, parks, and businesses. Keeping shared spaces clean and hygienic is crucial for maintaining a positive environment for residents and visitors."
                  ][index]}</p>
                </div>
              </div>
            ))}
          </div>

          <h2 className="fw-bold">How It Works</h2>
          <p className="text-muted">We’ve made pet waste removal simple and hassle-free. Our streamlined process ensures that you receive efficient and reliable service every time.</p>
            
        </section>
 */}
        {/* Our Process Section */}
        <section className="our-process py-5 bg-light">
          <div className="container text-center">
            <div className="row mt-4">
              {["Schedule a Service", "We Scoop the Poop", "Waste is Disposed", "Enjoy a Clean Yard"].map((step, index) => (
                <div className="col-md-3 d-flex" key={index}>
                  <div className="process-step flex-grow-1 p-4 shadow-sm bg-white rounded">
                    <h3 className="">{index + 1}. {step}</h3>
                    <p className="text-muted">{[
                      "Choose a plan that fits your needs—weekly, one-time, or custom cleanup. Our team is flexible and will work with your schedule to find the perfect time for service.",
                      "Our professionals arrive on time and thoroughly clean your yard. With attention to detail, we ensure that no mess is left behind, providing a comprehensive cleaning service.",
                      "We use eco-friendly disposal methods to keep your yard and the environment clean. Our waste management practices align with sustainability efforts to minimize environmental impact.",
                      "Relax and enjoy a fresh, poop-free lawn with your pets and family. A clean yard means a healthier outdoor space for playing, entertaining, and making memories."
                    ][index]}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Call-to-Action Section */}
        <section className="services-cta text-center py-5 text-white">
          <h3 className="fw-bold">Keep Your Yard Clean with Doggy Duty!</h3>
          <p className="lead">Choose a plan that fits your needs and let us handle the dirty work. Enjoy a cleaner, healthier yard today! Our friendly team is ready to assist you with top-quality pet waste removal services, ensuring your outdoor space remains safe, clean, and enjoyable.</p>
          <p className="lead">Why struggle with the mess when you can have a reliable team take care of it for you? Doggy Duty is committed to making pet ownership easier and stress-free. Contact us today to learn more about our services, pricing, and availability.</p>
          <a href="https://client.sweepandgo.com/doggy-duty-wny-g5m48/register" className="btn-primary" target="_blank" rel="noopener noreferrer">
          Get My Free Quote
          </a>
        </section>
      </div>

      
    </div>
  );
}

export default Services;
